import { useIntentContext } from '../../../contexts/Intent/hooks/useIntentContext.js';
import { useLocaleContext } from '../../../contexts/session/Locale.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';

var useAdsStylesContext = function useAdsStylesContext() {
  var _useIntentContext = useIntentContext(),
    intent = _useIntentContext.intent;
  var _useLocaleContext = useLocaleContext(),
    direction = _useLocaleContext.direction;
  var theme = useThemeContext();
  return {
    intent: intent,
    isLtr: direction === 'ltr',
    theme: theme
  };
};

export { useAdsStylesContext };
//# sourceMappingURL=useAdsStylesContext.js.map
